import * as React from 'react';

function ArrowRight2Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="arrow-right-2-icon_svg__icon"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      fill="currentColor"
      {...props}
    >
      <defs>
        <style />
      </defs>
      <path d="M689.621 512L360.789 183.168l-60.331 60.331L568.959 512 300.458 780.501l60.331 60.331z" />
    </svg>
  );
}

export default ArrowRight2Icon;
